<template>
  <transition name="fade" appear>
    <div class="transition-generic w-full wrapper-lg">
      ...
    </div>
  </transition>
</template>

<script>
export default {
  name: "CampanhaConfiguracao",
  components: {}
}
</script>
